export const yesNoStatuses = [
    {
        value: false,
        text: 'no',
    },
    {
        value: true,
        text: 'yes',
    }
];